import React, { useState, useEffect, useCallback } from "react";
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import { useDispatch, useSelector } from 'react-redux';
import 'react-datepicker/dist/react-datepicker.css';
import { getLocation, getAllLocationOneTimeGroup } from "../../../store/compose/actions"; //getPeopleByLocationId
import { updateOneTimePatientCount } from "../../../store/compose";
//import CustomDatePicker from '../../../components/CustomDatePicker/CustomDatePicker'
const appointmentTimeRange = {
    appointmentfrom: new Date(),
    appointmentto: new Date(),
    locations: null
};
appointmentTimeRange.appointmentto.setDate(appointmentTimeRange.appointmentto.getDate());

export default function ComposeOneTimeGroup({ show, onClose, handleCreateGroup }) {
    const dispatch = useDispatch();
    const { locationList } = useSelector(state => state.compose);
    const [groupData, setGroupData] = useState(appointmentTimeRange);
    const [selectedLocation, setSelectedLocation] = useState([]);
    const [errorMessage, setErrorMessage] = useState(null);
    const [isDateChange, setIsDateChange] = useState(false);
    const [oneTimePatientCount, SetOneTimePatientCount] = useState(0);
    useEffect(() => {
        dispatch(getAllLocationOneTimeGroup());
        setIsDateChange(false);
    }, []);

    useEffect(() => {
        dispatch(getLocation(groupData));
        setIsDateChange(false);
    }, [isDateChange, show]);


    useEffect(() => {
        const locationsToRemove = locationList.filter(x => x.noOfPeople === 0);

        const updatedLocation = selectedLocation.filter(
            location => !locationsToRemove.some(removeLocation => removeLocation.id === location.id)
        );

        const locationString = updatedLocation.map(obj => obj.id).join(',');
        const updatedGroupDate = { ...groupData, locations: locationString }
        setGroupData(updatedGroupDate);
        //dispatch(getPeopleByLocationId(updatedGroupDate));
        countPeopleInGroup();


        setSelectedLocation(updatedLocation);
    }, [locationList]);


    const handleStartDateChange = (date) => {
        const updatedGroupDate = { ...groupData, appointmentfrom: date }
        setGroupData(updatedGroupDate);
        if (groupData.locations !== null) {
            //dispatch(getPeopleByLocationId(updatedGroupDate));
            countPeopleInGroup();
            setErrorMessage(null);
        }
        setIsDateChange(true);
    };

    const handleEndDateChange = (date) => {
        const updatedGroupDate = { ...groupData, appointmentto: date }
        setGroupData(updatedGroupDate);
        if (groupData.locations !== null) {
            /*dispatch(getPeopleByLocationId(updatedGroupDate));*/
            SetOneTimePatientCount(0);
            setErrorMessage(null);
        }
        setIsDateChange(true);
    };

    const handleLocationToggle = (e, group) => {
        const checked = e.target.checked;
        const updatedLocation = checked
            ? [...selectedLocation, group]
            : selectedLocation.filter(item => item.id !== group.id);
        setSelectedLocation(updatedLocation);

        const locationString = updatedLocation.map(obj => obj.id).join(',');
        const updatedGroupDate = { ...groupData, locations: locationString }
        setGroupData(updatedGroupDate);
        countPeopleInGroup();
        setErrorMessage(null);
    }


    const countPeopleInGroup = () => {
        let total = 0;
        const checkboxes = document.querySelectorAll('.locationbox'); // Change '.admin-inline-checkbox' to your class name
        checkboxes.forEach((checkbox) => {
            const locationId = checkbox.value || '0';
            const isChecked = checkbox.checked;
            const location = locationList.find(location => location.id === parseInt(locationId));
            if (isChecked && location && location.noOfPeople > 0) {
                total += location.noOfPeople;
            }
        });

        SetOneTimePatientCount(total);
    };

    const handleOneTimeCreateGroup = () => {
        if (oneTimePatientCount > 0 && groupData.appointmentto > groupData.appointmentfrom) {
            let locationString = selectedLocation
                .filter(obj => locationList.some(x => x.id === obj.id))
                .map(obj => obj.id)
                .join(',');
            const updatedGroupDate = { ...groupData, locations: locationString }
            handleCreateGroup(updatedGroupDate, oneTimePatientCount);
            onClose();
            setSelectedLocation([]);
            setGroupData(appointmentTimeRange);
            dispatch(updateOneTimePatientCount());
        } else {
            setErrorMessage('No people in the group.');
        }
    }

    const handleOnClose = () => {
        onClose(); // Close the modal
        setErrorMessage(null);
        setSelectedLocation([]);
        dispatch(updateOneTimePatientCount());
    };


    const handleKeyDown = useCallback((event) => {
        if (event.key === 'Escape') {
            handleOnClose();
        }
    }, [handleOnClose]);

    useEffect(() => {
        if (show) {
            document.addEventListener('keydown', handleKeyDown);
        } else {
            document.removeEventListener('keydown', handleKeyDown);
        }

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [show, handleKeyDown]);

    if (!show) {
        return null;
    }
    return (
        <div className="admin-modal-overlay one-time-group-modal select-group-modal">
            <div className="admin-modal wide modal-header-border">
                <button className="admin-modal-close modal-close" onClick={handleOnClose}>
                    <span className="material-symbols-rounded">close</span>
                </button>
                <h2 className="admin-modal-heading heading-align-right">Create One-time Group</h2>
                <div className="admin-modal-scroll">
                    <div className="admin-modal-row">
                        <div className="admin-modal-cell">
                            <label className="admin-default-label" htmlFor="appointment-time-range">
                                Appointment Time Range
                            </label>
                            <div className="modal-appointment-date-range">
                                {/*<CustomDatePicker*/}
                                {/*    className="admin-default-input-text one-time-datepicker"*/}
                                {/*    selected={groupData.appointmentfrom}*/}
                                {/*    placeholder="mm/dd/yyyy"*/}
                                {/*    autoComplete="off"*/}
                                {/*    onChange={handleStartDateChange}*/}
                                {/*    selectsStart*/}
                                {/*    maxDate={(function () {*/}
                                {/*        const maxDate = new Date();*/}
                                {/*        maxDate.setDate(maxDate.getDate() + 7);*/}
                                {/*        return maxDate;*/}
                                {/*    })()}*/}
                                {/*    varient="BtnFalse"*/}
                                {/*/>*/}
                                <DatePicker
                                    className="admin-default-input-text"
                                    selected={groupData?.appointmentfrom}
                                    selectsStart
                                    placeholder="mm/dd/yyyy"
                                    onChange={handleStartDateChange}
                                    maxDate={(function () {
                                        const maxDate = new Date();
                                        maxDate.setDate(maxDate.getDate() + 7);
                                        return maxDate;
                                    })()}
                                />
                                <DatePicker
                                    className="admin-default-input-text"
                                    selected={groupData?.appointmentfrom}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    dateFormat="hh:mm aa"
                                    placeholder="hh:mm aa"
                                    timeIntervals={15}
                                    onChange={handleStartDateChange}
                                />
                                <span>&nbsp; to &nbsp;</span>
                                <DatePicker
                                    className="admin-default-input-text"
                                    selected={groupData?.appointmentto}
                                    selectsEnd
                                    placeholder="mm/dd/yyyy"
                                    onChange={handleEndDateChange}
                                    minDate={groupData?.appointmentfrom}
                                    maxDate={(function () {
                                        const maxDate = new Date();
                                        maxDate.setDate(maxDate.getDate() + 7);
                                        return maxDate;
                                    })()}
                                />
                                <DatePicker
                                    className="admin-default-input-text"
                                    selected={groupData?.appointmentto}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    dateFormat="hh:mm aa"
                                    placeholder="hh:mm aa"
                                    timeIntervals={15}
                                    onChange={handleEndDateChange}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="admin-modal-row modal-locations">
                        <div className="admin-modal-cell">
                            <label className="admin-default-label" htmlFor="location">
                                Select Locations
                            </label>
                            <div className="admin-column-wrap auto-columns">
                                {locationList && locationList.map(location => (
                                    <label className="admin-checkbox-label inline inline-width-50" key={location?.id}>
                                        <input
                                            className="admin-inline-checkbox locationbox"
                                            type="checkbox"
                                            value={location.id}
                                            disabled={location?.noOfPeople === 0}
                                            checked={selectedLocation && selectedLocation.some(x => x.id === location?.id && x.noOfPeople > 0)}
                                            onChange={(e) => {
                                                handleLocationToggle(e, location);
                                            }}
                                        />
                                        {location?.name} ({location?.noOfPeople})
                                    </label>
                                ))}
                                {locationList && locationList.length === 0 && <p className="admin-legend-label">No Locations</p>}
                            </div>
                        </div>
                    </div>

                </div>
                <div className="admin-modal-button-wrap">
                    {errorMessage && <p className="error-messagess">{errorMessage}</p>}
                    {oneTimePatientCount > 0 ? <p className="admin-legend-label">{oneTimePatientCount === 1 ? '1 Person in Group' : `${oneTimePatientCount} People in Group`} </p> : null}
                    <button className="admin-modal-button power" onClick={handleOneTimeCreateGroup}>
                        Create Group
                    </button>
                </div>
            </div>
        </div>
    );
}


ComposeOneTimeGroup.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    handleCreateGroup: PropTypes.func.isRequired,
    modelPosting: PropTypes.object,
};